import React from 'react'

const AllStatesPreviousSearchesColumns = () => {
    return (
        <div className='uccColumns bg-white rounded'>
            <div className='row'>
                <div className='col-md-3'>
                    <strong>Business Name</strong>
                </div>
                <div className='col-md-2'>
                    <strong>Search Date</strong>
                </div>
                <div className='col-md-2'>
                    <strong>Status</strong>
                </div>
                <div className='col-md-2'>
                    <strong>Best Match</strong>
                </div>
                <div className='col-md-3'>
                    <strong>Actions</strong>
                </div>
            </div>
        </div>
    )
}

export default AllStatesPreviousSearchesColumns